import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import vuexAlong from "vuex-along";

Vue.use(Vuex);

const moduleFiles = require.context("./modules", true, /\.js$/);
const modulesOBJ = {};

let modules = moduleFiles.keys().forEach(element => {
  const moduleName = element.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = moduleFiles(element);
  modulesOBJ[moduleName] = value.default;

  return modulesOBJ;
});

modules = modulesOBJ;
export default new Vuex.Store({
  getters,
  modules,
  plugins: [
    vuexAlong({
      name: "userinfo",
      local: {
        list: ["modules"],
        isFilter: true
      },
      session: {
        list: ["userinfo"]
      }
    })
  ]
});
